import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../../template/template.component";

@Component({
  selector: 'app-feature-section-item',
  standalone: true,
    imports: [
        NgIf
    ],
  templateUrl: './feature-section-item.component.html',
  styleUrl: './feature-section-item.component.css'
})
export class FeatureSectionItemComponent extends TemplateComponent{
  @Input() logoPath: string = "";
  @Input() backColor: string="#ffffff";
  @Input() fontColor: string="#000000";
  @Input() title: string ='';
  @Input() text: string='';
  @Input() pageUid: string='';

  // constructor(public route: Router) {
  // }
  goToPage() {
    this.route.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.route.navigate(['feature/'+this.pageUid]);
    });

  }
}
